export function sendOpenPhonePopupEvent (where) {
    analytics.submitSeePhoneOpen(where);
}

export function sendOpenContactPopupEvent(where) {
    analytics.submitSendContactOpen(where);
}
